export class SessionCheck {
  constructor() {
    document.addEventListener('DOMContentLoaded', function () {
      const trgs = document.querySelectorAll('.js-reserve_trg')
      let reservationText = ''
      let cancelText = ''

      const formLang = document.querySelector('.js-form')
      if (!formLang) return
      if (formLang.classList.contains('js-form_en')) {
        reservationText = 'Select'
        cancelText = 'Cancel'
      } else {
        reservationText = '予約する'
        cancelText = 'キャンセル'
      }

      trgs.forEach((data) => {
        data.addEventListener('change', (e) => {
          const target = e.currentTarget

          const label = target.querySelector('.js-reserve_text')
          const targetBlock = target.closest('.js-session_block')
          const targetCard = target.closest('.js-session_card')
          target.classList.toggle('is-cancel')
          targetCard.classList.toggle('is-act')
          if (target.classList.contains('is-cancel')) {
            if (label) {
              label.textContent = cancelText
            }
          } else {
            if (label) {
              label.textContent = reservationText
            }
          }
          const cards = targetBlock.querySelectorAll('.js-session_card')
          cards.forEach((elm) => {
            elm.classList.remove('is-disabled')
            if (!elm.classList.contains('is-act') || elm.classList.contains('is-sold')) {
              elm.classList.add('is-disabled')
            }
          })
          if (label) {
            if (label.textContent === reservationText) {
              cards.forEach((elm) => {
                if (!elm.classList.contains('is-sold')) {
                  elm.classList.remove('is-disabled')
                }
              })
            }
          }
        })
      })
    })
  }
}
